module.exports = __webpack_public_path__ + "img/login.d00b2197.png";